import { Spacing } from '../constants/spacing';
export const SnackbarType = {
  INFO: 'info',
  ERROR: 'error',
  SUCCESS: 'success'
};
export const SNACKBAR_AUTO_HIDE_TIME_MS = 3000;
export const SNACKBAR_TRANSITION_TIMEOUT_MS = 300;
export const SNACKBAR_BOTTOM_SPACING = Spacing.SPACE_24;